import { CellContext, createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import React, { useState } from "react";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import { IDesviacion } from "../../../../entities/IDesviacion";
import { IEstadoCausa } from "../../../../entities/IEstadoCausa";
import IGerencia from "../../../../entities/IGerencia";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_DESVIACION,
  API_ADMIN_ESTADO_CAUSA,
  API_ADMIN_GERENCIA,
  API_ADMIN_UNIDAD,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import DesviacionService from "../../../../services/DesviacionService";
import VppService from "../../../../services/VppService";
import CscService from "../../../../services/CscService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActive, cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { downloadFile } from "../../../../helpers/fileHelper";
import Loading from "../../../../cross/Loading";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";

const MySwal = withReactContent(Swal);
const TIPO_CAUSA_LABEL_AMBITO_GESTION = "ÁMBITO GESTIÓN";
const TIPO_CAUSA_SISTEMA_CANONICO = "SISTEMA";

export const normalizeTipoCausa = (tipoCausa: any): any => {
  if (typeof tipoCausa !== "string") {
    return tipoCausa;
  }
  return tipoCausa.trim().toUpperCase() === TIPO_CAUSA_LABEL_AMBITO_GESTION ? TIPO_CAUSA_SISTEMA_CANONICO : tipoCausa;
};

interface IMantenedorCausasProps {
  items?: Array<any>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbEstadoCausa?: Array<IEstadoCausa>;
}
export default function MantenedorCausas({
  items,
  cbVicepresidencia,
  cbGerenciaSubgerencia,
  cbUnidadProyecto,
  cbContratistaSubcontratista,
  cbEstadoCausa,
  itemsArrCambios,
}: IMantenedorCausasProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();

  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVcc, setComboVcc] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUP, setComboUP] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSG, setComboGSG] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboCSC, setComboCSC] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboEC, setComboEC] = useState<Array<IEstadoCausa>>(cbEstadoCausa || []);
  const [isEditColum, setIsEditColum] = useState<boolean>(false);
  const [editColumnInfo, setEditColumnInfo] = useState<any>();
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [showToast, setShowToast] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [arrCambiosForm, setArrCambiosForm] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambios, setIsOpenPopUpGuardarCambios] = useState<boolean>(false);
  const refTxtCorr = React.createRef<HTMLInputElement>();
  const [refComboVcc, setValComboVcc] = useState<IComboboxOption | null>(null);
  const [refComboUP, setValComboUP] = useState<IComboboxOption | null>(null);
  const [refComboGSG, setValComboGSG] = useState<IComboboxOption | null>(null);
  const [refComboCSC, setValComboCSC] = useState<IComboboxOption | null>(null);
  const [refComboEC, setValComboEC] = useState<IComboboxOption | null>(null);
  const [selectedField, setSelectedField] = useState({} as any);
  const refTxtMotivo = React.createRef<HTMLTextAreaElement>();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [isSendingData, setIsSendingData] = useState(false);
  const columnHelperMantDesviaciones = createColumnHelper<IDesviacion>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };

  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const componentValorNuevo = (value: any) => {
    console.log("shortDate(value.getValue())", value.getValue());
    if (value.getValue()?.TIPO === ITipo_Campo.user) {
      return <i>{value.getValue()[`${value.getValue().ID}_DISPLAY`]}</i>;
    } else if (value.getValue()?.TIPO === ITipo_Campo.date) {
      return <i>{shortDate(value.getValue())}</i>;
    } else {
      return <i>{value.getValue()}</i>;
    }
  };

  const componentDesactivar = (value: any) => {
    let desactivar = value.row.original.ACTIVO ? "Desactivar" : "Activar";
    return (
      <button
        className="btnIcono"
        title={desactivar}
        onClick={() => {
          MySwal.fire({
            html: (
              <div>
                <h3>
                  ¿Desea {desactivar.toLowerCase()} el registro {value.row.original.CORRELATIVO}?
                </h3>
              </div>
            ),
            text: "",
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  if (!txtMotivo) {
                    Swal.showValidationMessage(`Debe ingresar un motivo`);
                  } else {
                    await DesviacionService.desactivarCausaRegistro(token, {
                      ID_REGISTRO: value.row.original.ID_CAUSA as number,
                      AUTOR: currentUser?.email as string,
                      AUTOR_DISPLAY: currentUser?.fullname as string,
                      CAMPO: "N/A",
                      EDITOR: currentUser?.email as string,
                      EDITOR_DISPLAY: currentUser?.fullname as string,
                      MODULO: "DESVIACIONES",
                      TABLA: value.row.original.TIPO_CAUSA,
                      MOTIVO: txtMotivo,
                      VALOR_INICIAL: "N/A",
                      DESACTIVAR: value.row.original.ACTIVO as boolean,
                      FECHA_CREACION: new Date(),
                      FECHA_MODIFICACION: new Date(),
                      VALOR_FINAL: "N/A",
                      ACCION: desactivar.toUpperCase(),
                      CORRELATIVO: value.row.original.CORRELATIVO,
                    });
                    await handleBuscar();
                  }
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                console.log(result);
              });
            }
          });
        }}>
        <i className={value.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
      </button>
    );
  };

  const changeField = (id: string, valor: any, tipo: ITipo_Campo) => {
    setSelectedField({});
    let selectedField: any = {};
    if (id) {
      if (typeof valor === "string" || typeof valor === "boolean") {
        selectedField[id] = valor;
      } else {
        let mail = valor[0].mail;
        selectedField[id] = valor[0].mail;
        let name = valor[0].name;
        name = name.replace(` (${mail})`, "");
        selectedField[`${id}_DISPLAY`] = name;
        selectedField[`ID`] = id;
      }
      selectedField[`TIPO`] = tipo;
      setSelectedField(selectedField);
    }
  };

  let columnsDef = [
    columnHelperMantDesviaciones.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `DESV."CORRELATIVO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.ID, {
      id: "DESACTIVAR",
      cell: (info: CellContext<IDesviacion, number>) => componentDesactivar(info),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IDesviacion, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.TIPO_CAUSA, {
      id: "TIPO_CAUSA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Causa"),
      hide: false,
      title: "Tipo Causa",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_CAUSA"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.ESTADO, {
      id: "ESTADO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      hide: false,
      title: "Estado",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `EV."NOMBRE"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.ASUNTO, {
      id: "ASUNTO",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Asunto"),
      hide: false,
      title: "Asunto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `DESV."ASUNTO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `VPP."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `GSG."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `UP."TITULO"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      hide: false,
      title: "Acción",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ACCION"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Asignación"),
      hide: false,
      title: "Fecha Detección",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `"FECHA_ASIGNACION"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => row.RESPONSABLE_DISPLAY || row.RESPONSABLE, {
      id: "RESPONSABLE",
      cell: (info: CellContext<IDesviacion, string>) => componentLink(info.getValue()),
      header: () => component("Responsable"),
      hide: false,
      title: "Responsable",
      tipo: ITipo_Campo.user,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColum(true);
        setIsSendingData(false);
      },
      sortId: `"RESPONSABLE"`,
    } as any),
    columnHelperMantDesviaciones.accessor((row) => shortDate(row.FECHA_HASTA), {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IDesviacion, string>) => componentLink(info.getValue()),
      header: () => component("Fecha Hasta"),
      hide: false,
      title: "Fecha Hasta",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfo(cell);
        setIsEditColum(true);
        setIsSendingData(false);
      },
      sortId: `"FECHA_HASTA"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    try {
      const comboVcc = (await VppService.getAll(token, paramsActive)).result.data;
      setComboVcc(comboVcc);
      const comboCSC = (await CscService.getAll(token, paramsActive)).result.data;
      setComboCSC(comboCSC);
      let comboEC = (await getAPI(`${URL_SUPPORT}${API_ADMIN_ESTADO_CAUSA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)).result.data;
      comboEC = comboEC.filter((ec: any) => ec.ID === 1 || ec.ID === 2 || ec.ID === 3);
      setComboEC(comboEC);
    } catch (e) {
      console.log(e);
    }
  }, []);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };

  const filter = (filter: any, page: boolean = false, size = pageSize) => {
    setIsLoading(true);
    if (!filter) {
      filter = {};
    }
    filter.TIPO_FACTOR = filter.ID_TIPO_FACTOR?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = 1;
    }
    if (!page) {
      filter.PAGINA = 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVcc?.value;
    const valUP = refComboUP?.value;
    const valGSG = refComboGSG?.value;
    const valCSC = refComboCSC?.value;
    const valEC = refComboEC?.value;
    filter.UNIDAD_PROYECTO = valUP;
    filter.GERENCIA_SUBGERENCIA = valGSG;
    filter.VICEPRESIDENCIA = valVcc;
    filter.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filter.ESTADO = valEC;
    filter.CORRELATIVO = valCorr;

    getAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/GetAllMantenedorCausa`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const exportFile = () => {
    const valCorr = refTxtCorr.current?.value;
    const valVcc = refComboVcc?.value;
    const valUP = refComboUP?.value;
    const valGSG = refComboGSG?.value;
    const valCSC = refComboCSC?.value;
    const valED = refComboEC?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `DESV."ID"`,
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/Export`, { Authorization: `Bearer ${token}` }, params)
      .then((r) => {
        downloadFile(r.result);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const edit = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID == "") {
      delete value.ID;
    }
  };

  const handleBuscar = async () => {
    setHideTable(true);
    setIsLoading(true);
    const valCorr = refTxtCorr.current?.value === "Seleccione" ? "" : refTxtCorr.current?.value;
    const valVcc = refComboVcc?.value === "Seleccione" ? "" : refComboVcc?.value;
    const valUP = refComboUP?.value === "Seleccione" ? "" : refComboUP?.value;
    const valGSG = refComboGSG?.value === "Seleccione" ? "" : refComboGSG?.value;
    const valCSC = refComboCSC?.value === "Seleccione" ? "" : refComboCSC?.value;
    const valED = refComboEC?.value === "Seleccione" ? "" : refComboEC?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: `DESV."ID"`,
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
    };
    const result = (await getAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/GetAllMantenedorCausa`, { Authorization: `Bearer ${token}` }, params)).result;
    setArrCambiosForm([]);
    let list = result !== undefined ? result.data : [];
    console.log(list);
    setListItems(list);
    let pages = result !== undefined ? result.pages : 0;
    setPages(pages);
    console.log(list);
    setListItems(list);
    setHideTable(false);
    setIsLoading(false);
  };

  const cambios = () => {
    let arrDesviaciones: Array<IDesviacion> = [];
    let arrLogs: Array<ILogMantenedor> = [];

    arrCambiosForm.forEach((ac) => {
      if (!arrDesviaciones.find((d) => d.ID === ac.ID)) {
        arrDesviaciones.push(ac.OBJETO_REF);
      }
    });

    arrDesviaciones.forEach((d: any) => {
      arrCambiosForm
        .filter((ac) => ac.ID === d.ID)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "DESVIACIONES",
            TABLA: "BASICA",
            ID_REGISTRO: d.ID_CAUSA,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivo.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.CORRELATIVO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else if (ac.TIPO === ITipo_Campo.date) {
            d[ac.CAMPO_EDITADO_ID] = moment(moment(ac.VALOR_NUEVO).format(moment.HTML5_FMT.DATE)).toDate();
            log.VALOR_FINAL = ac.VALOR_NUEVO.FECHA_HASTA;
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    arrDesviaciones.forEach((d: any) => {
      d.TIPO_CAUSA = normalizeTipoCausa(d.TIPO_CAUSA);
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      DESVIACIONES: arrDesviaciones,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_DESVIACION}/MantenedorDesviacionCausa`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        setArrCambiosForm([]);
        if (refTxtMotivo.current) {
          refTxtMotivo.current.value = "";
        }
        setIsOpenPopUpGuardarCambios(false);
        setShowToast(true);
        let data = result.result.data;
        console.log(data);
        let params = { PAGINA: page };
        filter(params);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section>
      {isLoading && <Loading key="loadingDownload" cssContainer="loadingFlotante" />}
      <div className="row">
        <button
          hidden={true}
          data-testid="btnedit"
          onClick={() => {
            edit({ AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID: "" }, {});
          }}></button>
        <button
          hidden={true}
          data-testid="btnexport"
          onClick={() => {
            exportFile();
          }}></button>
        <button
          hidden={true}
          data-testid="btncambios"
          onClick={() => {
            cambios();
          }}></button>
        <button
          hidden={true}
          data-testid="btnchange"
          onClick={() => {
            changeField("1", "ddd", ITipo_Campo.text);
            changeField("1", [{ mail: "", name: "" }], ITipo_Campo.text);
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Desviaciones - Causas</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <div className="col-6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorr} className="form-control form-control-sm" />
                  </Col>
                </div>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={
                      comboVcc.map((vcc) => ({
                        value: vcc.TITULO,
                        label: vcc.TITULO,
                      })) as any
                    }
                    placeholder="Seleccione"
                    value={refComboVcc || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVcc(e);
                      let paramsActive = {
                        ...cParamsActive,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSG = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSG([]);
                        setComboGSG(comboGSG);
                        setComboUP([]);
                      } else {
                        setComboGSG([]);
                        setComboUP([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSG || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSG.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSG(e);
                      let paramsActive = {
                        ...cParamsActive,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUP = (await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive))
                          .result.data;
                        setComboUP(comboUP);
                      } else {
                        setComboUP([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUP || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUP.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUP(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6"></Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Contratista/Subcontratista:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboCSC || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboCSC.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboCSC(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Estado Causa:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboEC || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboEC.filter((ec) => ec.ID != 4 && ec.ID != 5).map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboEC(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={async () => {
                      handleBuscar();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>
                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => {
                      (refTxtCorr.current as HTMLInputElement).value = "";
                      setValComboVcc(null);
                      setValComboUP(null);
                      setValComboGSG(null);
                      setValComboCSC(null);
                      setValComboEC(null);
                      setListItems([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>
                  {arrCambiosForm.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambios(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filter}
          items={[]}
          callback={edit}
          data={listItems}
          tipo={"MantenedorDesviaciones"}
          filter={filter}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          columnsDef={columnsDef}
          hideExport={true}
          hideAdd={true}
          exportar={exportFile}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filter(filters, false, pageSize);
          }}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setIsEditColum(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>{editColumnInfo && editColumnInfo?.getValue()}</div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfo?.column?.id}
                      tipoCampo={editColumnInfo?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let txtError = [];
                    let json = selectedField;
                    let arr = arrCambiosForm;
                    json = {
                      ID: editColumnInfo.row.original.ID_CAUSA,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfo.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfo?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.user || editColumnInfo.column.columnDef.tipo === ITipo_Campo.date
                          ? selectedField
                          : selectedField[editColumnInfo.column.columnDef.id],
                      OBJETO_REF: {
                        ...editColumnInfo.row.original,
                        ID: editColumnInfo.row.original.ID_CAUSA,
                      },
                      TIPO: editColumnInfo.column.columnDef.tipo,
                      TABLA_EDITADA: editColumnInfo.row.original.TIPO_CAUSA,
                    };
                    if (
                      editColumnInfo.column.columnDef.tipo === ITipo_Campo.date &&
                      json.VALOR_ORIGINAL === shortDate(json.VALOR_NUEVO.FECHA_HASTA)
                    ) {
                      txtError.push("La fecha debe ser distinta a la actual");
                    } else if (
                      editColumnInfo.column.columnDef.tipo === ITipo_Campo.user &&
                      json.VALOR_ORIGINAL === json.VALOR_NUEVO[json.VALOR_NUEVO.ID + "_DISPLAY"]
                    ) {
                      txtError.push("El usuario debe ser distinto al actual");
                    } else if (json.VALOR_ORIGINAL === json.VALOR_NUEVO) {
                      txtError.push("El valor debe ser distinto al actual");
                    }
                    if (!isSendingData && txtError.length === 0) {
                      arr.push(json);
                      setArrCambiosForm(arr);
                      setIsEditColum(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColum(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambios && (
        <Offcanvas
          show={isOpenPopUpGuardarCambios}
          onHide={() => {
            setIsOpenPopUpGuardarCambios(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Desviaciones:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filter}
                items={[]}
                callback={edit}
                data={arrCambiosForm}
                tipo={"MantenedorDesviaciones"}
                filter={filter}
                pagination={{ pages: pages, page: page, paging: paging }}
                title=""
                hideExport={true}
                hideAdd={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((row) => row.ID, {
                    id: "ID",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.TABLA_EDITADA, {
                    id: "TABLA_EDITADA",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Tabla Editada"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (info: CellContext<IConfirmacionMantenedor, string>) => componentValue(info.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((row) => row.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (info: CellContext<IConfirmacionMantenedor, any>) => componentValue(info.getValue(), info.getValue()?.TIPO),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivo} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivo.current?.value) {
                      refTxtMotivo.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivo.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivo.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        cambios();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambios(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
